import React from "react";
import { TableCell, TableRow, TableSortLabel } from "@mui/material";
import { PolygonData } from "types/models/master/MasterApp";

interface TableHeadingProps {
  orderBy: keyof any;
  order: "asc" | "desc";
  onSort: (property: keyof PolygonData) => void;
}

const TableHeading: React.FC<TableHeadingProps> = ({ orderBy, order, onSort }) => {
  const createSortHandler = (property: keyof PolygonData) => () => {
    onSort(property);
  };

  const commonCellStyle = {
    fontSize: 14,
    width: 200,
    maxWidth: 180,
    minWidth: 160,
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
  };

  return (
    <TableRow>
      <TableCell
        sx={commonCellStyle}
        sortDirection={orderBy === "stateName" ? order : false}
      >
        <TableSortLabel
          active={orderBy === "stateName"}
          direction={orderBy === "stateName" ? order : "asc"}
          onClick={createSortHandler("stateName")}
        >
          State
        </TableSortLabel>
      </TableCell>

      <TableCell
        sx={commonCellStyle}
        sortDirection={orderBy === "city_name" ? order : false}
      >
        <TableSortLabel
          active={orderBy === "city_name"}
          direction={orderBy === "city_name" ? order : "asc"}
          onClick={createSortHandler("city_name")}
        >
          City
        </TableSortLabel>
      </TableCell>

      <TableCell
        sx={commonCellStyle}
        sortDirection={orderBy === "area_name" ? order : false}
      >
        <TableSortLabel
          active={orderBy === "area_name"}
          direction={orderBy === "area_name" ? order : "asc"}
          onClick={createSortHandler("area_name")}
        >
          Area
        </TableSortLabel>
      </TableCell>

      <TableCell
        sx={commonCellStyle}
        sortDirection={orderBy === "groupid" ? order : false}
      >
        <TableSortLabel
          active={orderBy === "groupid"}
          direction={orderBy === "groupid" ? order : "asc"}
          onClick={createSortHandler("groupid")}
        >
          Network Partner
        </TableSortLabel>
      </TableCell>

      <TableCell
        sx={commonCellStyle}
        sortDirection={orderBy === "isActive" ? order : false}
      >
        <TableSortLabel
          active={orderBy === "isActive"}
          direction={orderBy === "isActive" ? order : "asc"}
          onClick={createSortHandler("isActive")}
        >
          Polygon Status
        </TableSortLabel>
      </TableCell>

      <TableCell
        sx={commonCellStyle}
        sortDirection={orderBy === "status" ? order : false}
      >
        <TableSortLabel
          active={orderBy === "status"}
          direction={orderBy === "status" ? order : "asc"}
          onClick={createSortHandler("status")}
        >
          Status
        </TableSortLabel>
      </TableCell>

      <TableCell sx={commonCellStyle} align="left">
        Action
      </TableCell>
    </TableRow>
  );
};

export default TableHeading;
